import { useContext } from "react";
import { ConfigContext } from "../providers/ConfigContext";
import useMakeApiRequest from "./useMakeApiRequest";

const useTokenARBalance = () =>{
    const { apiBase } = useContext(ConfigContext);
    const makeApiRequest = useMakeApiRequest('GET');

    const tokenARBalance = async (token: any) => {
        return await makeApiRequest(`${apiBase}/api/v1/parseToken?token=${token}`);
    }

    return tokenARBalance;

}
export default useTokenARBalance;